import { CheckCircle2, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

interface IAMVerificationBannerProps {
  isVerified: boolean;
  onVerify?: () => void;
  compact?: boolean;
}

export function IAMVerificationBanner({ 
  isVerified, 
  onVerify,
  compact = false 
}: IAMVerificationBannerProps) {
  const { t } = useLanguage();

  if (isVerified) {
    return (
      <div className={`flex items-center gap-3 rounded-lg bg-green-50 dark:bg-green-950/30 border border-green-200 dark:border-green-800 ${compact ? 'p-2' : 'p-4'}`}>
        <CheckCircle2 className="h-5 w-5 text-green-600 dark:text-green-400 flex-shrink-0" />
        <div className="flex-1">
          <span className="font-medium text-green-700 dark:text-green-300">
            {t("تم التحقق من الهوية", "IAM Verified")}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 rounded-lg bg-red-50 dark:bg-red-950/30 border border-red-200 dark:border-red-800 ${compact ? 'p-2' : 'p-4'}`}>
      <AlertCircle className="h-5 w-5 text-red-600 dark:text-red-400 flex-shrink-0" />
      <div className="flex-1">
        <p className="font-medium text-red-700 dark:text-red-300">
          {t("لم يتم التحقق من الهوية", "IAM not Verified")}
        </p>
        {!compact && (
          <p className="text-sm text-red-600 dark:text-red-400 mt-1">
            {t("يجب التحقق من حسابك عبر نظام الهوية الوطنية", "You must verify your account through IAM")}
          </p>
        )}
      </div>
      {onVerify && (
        <Button 
          onClick={onVerify}
          className="bg-primary hover:bg-primary/90"
          size={compact ? "sm" : "default"}
        >
          {t("تحقق", "Verify")}
        </Button>
      )}
    </div>
  );
}
